/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, jira/naming/disallow-filenames */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, cssMap, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

const sizeStyles = cssMap({
	small: {
		width: '16px',
		height: '16px',
	},
	medium: {
		width: '24px',
		height: '24px',
	},
	large: {
		width: '32px',
		height: '32px',
	},
	xlarge: {
		width: '48px',
		height: '48px',
	},
});

const svgStyles = css({
	fill: token('elevation.surface'),
	overflow: 'hidden',
	pointerEvents: 'none',
});
interface CustomerExperienceCustomIconProps {
	size?: 'small' | 'medium' | 'large' | 'xlarge';
}

const CustomerExperienceCustomIcon = ({ size = 'medium' }: CustomerExperienceCustomIconProps) => (
	<Box xcss={iconStyles}>
		<svg
			viewBox="-4 -4 24 24"
			role="presentation"
			color="var(--ds-icon)"
			css={[svgStyles, sizeStyles[size]]}
		>
			<path
				fill="currentcolor"
				fillRule="evenodd"
				d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z"
				clipRule="evenodd"
			/>
		</svg>
	</Box>
);

const iconStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: 'radius.small',
	backgroundColor: 'color.background.accent.orange.subtlest.pressed',
});

export const CustomerExperienceIcon: React.FC<CustomerExperienceCustomIconProps> =
	CustomerExperienceCustomIcon;
